module.exports = __webpack_public_path__ + "static/media/card_02.8fcbc284.png";